import { render, staticRenderFns } from "./loginPage.vue?vue&type=template&id=1fcc9816&scoped=true"
import script from "./loginPage.vue?vue&type=script&lang=js"
export * from "./loginPage.vue?vue&type=script&lang=js"
import style0 from "./loginPage.vue?vue&type=style&index=0&id=1fcc9816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcc9816",
  null
  
)

export default component.exports